var map = {
	"./bark_beetle/en/bark-beetle-observations-cropped.png": 24641,
	"./bark_beetle/en/bark-beetle-pre-observations-cropped.png": 63911,
	"./bark_beetle/sv/bark-beetle-observations-cropped.png": 666,
	"./bark_beetle/sv/bark-beetle-pre-observations-cropped.png": 62434,
	"./final_felling_drone_praxis/en/IMG_0001.png": 39488,
	"./final_felling_drone_praxis/en/IMG_0002.png": 52092,
	"./final_felling_drone_praxis/en/felling-drone-praxis-1-cropped.png": 19438,
	"./final_felling_drone_praxis/en/felling-drone-praxis-2-cropped.png": 67759,
	"./final_felling_drone_praxis/en/felling-drone-praxis-3-cropped.png": 77528,
	"./final_felling_drone_praxis/sv/IMG_0001.png": 66128,
	"./final_felling_drone_praxis/sv/IMG_0002.png": 61410,
	"./final_felling_drone_praxis/sv/felling-drone-praxis-1-cropped.png": 32209,
	"./final_felling_drone_praxis/sv/felling-drone-praxis-2-cropped.png": 53909,
	"./final_felling_drone_praxis/sv/felling-drone-praxis-3-cropped.png": 87174,
	"./guides/en/control-final-felling.png": 69302,
	"./guides/en/damage-inventory.png": 36904,
	"./guides/en/planning-projects.png": 12579,
	"./guides/sv/control-final-felling.png": 3925,
	"./guides/sv/damage-inventory.png": 14055,
	"./guides/sv/planning-projects.png": 84805,
	"./kopparfors_windfall/en/kopparfors-windfall-1-cropped.png": 68490,
	"./kopparfors_windfall/en/kopparfors-windfall-2-cropped.png": 20072,
	"./kopparfors_windfall/en/kopparfors-windfall-3-cropped.png": 23231,
	"./kopparfors_windfall/sv/kopparfors-windfall-1-cropped.png": 15001,
	"./kopparfors_windfall/sv/kopparfors-windfall-2-cropped.png": 65035,
	"./kopparfors_windfall/sv/kopparfors-windfall-3-cropped.png": 71481,
	"./manual_action_planning/en/Adding Action Objects to Action Plans - 1.png": 36890,
	"./manual_action_planning/en/Adding Action Objects to Action Plans - 2.png": 41868,
	"./manual_action_planning/en/Adding Action Objects to Action Plans - 3.png": 62127,
	"./manual_action_planning/en/Adding Action Objects to Action Plans - 4.png": 82291,
	"./manual_action_planning/en/Adding Action Objects to Action Plans - 5.png": 98626,
	"./manual_action_planning/en/Adding Actions to Action Plans - 1.png": 5237,
	"./manual_action_planning/en/Adding Actions to Action Plans - 2.png": 26562,
	"./manual_action_planning/en/Adding Actions to Action Plans - 3.png": 65764,
	"./manual_action_planning/en/Adding Actions to Action Plans - 4.png": 44189,
	"./manual_action_planning/en/Adding Library Images to Project Images - 1.png": 81809,
	"./manual_action_planning/en/Adding Library Images to Project Images - 2.png": 90088,
	"./manual_action_planning/en/Adding Map Snapshots to Project Images - 1.png": 2189,
	"./manual_action_planning/en/Adding Map Snapshots to Project Images - 2.png": 24541,
	"./manual_action_planning/en/Adding Point Observation Images to Project Images - 1.png": 54514,
	"./manual_action_planning/en/Adding Point Observation Images to Project Images - 2.png": 75075,
	"./manual_action_planning/en/Gallery View.png": 92873,
	"./manual_action_planning/en/Generating Action Proposal PDFs - 1.png": 59334,
	"./manual_action_planning/en/Generating Action Proposal PDFs - 2.png": 30055,
	"./manual_action_planning/en/Generating Action Proposal PDFs - 3.png": 29067,
	"./manual_action_planning/en/Generating Action Proposal PDFs - 4.png": 44281,
	"./manual_action_planning/en/Removing Actions from Action Plans - 1.png": 18818,
	"./manual_action_planning/en/Removing Actions from Action Plans - 2.png": 59717,
	"./manual_action_planning/sv/Adding Action Objects to Action Plans - 1.png": 84349,
	"./manual_action_planning/sv/Adding Action Objects to Action Plans - 2.png": 73684,
	"./manual_action_planning/sv/Adding Action Objects to Action Plans - 3.png": 39313,
	"./manual_action_planning/sv/Adding Action Objects to Action Plans - 4.png": 30511,
	"./manual_action_planning/sv/Adding Action Objects to Action Plans - 5.png": 96194,
	"./manual_action_planning/sv/Adding Actions to Action Plans - 1.png": 80382,
	"./manual_action_planning/sv/Adding Actions to Action Plans - 2.png": 65603,
	"./manual_action_planning/sv/Adding Actions to Action Plans - 3.png": 72929,
	"./manual_action_planning/sv/Adding Actions to Action Plans - 4.png": 24533,
	"./manual_action_planning/sv/Adding Library Images to Project Images - 1.png": 43359,
	"./manual_action_planning/sv/Adding Library Images to Project Images - 2.png": 96592,
	"./manual_action_planning/sv/Adding Map Snapshots to Project Images - 1.png": 36805,
	"./manual_action_planning/sv/Adding Map Snapshots to Project Images - 2.png": 18314,
	"./manual_action_planning/sv/Adding Point Observation Images to Project Images - 1.png": 66184,
	"./manual_action_planning/sv/Adding Point Observation Images to Project Images - 2.png": 80148,
	"./manual_action_planning/sv/Gallery View.png": 47591,
	"./manual_action_planning/sv/Generating Action Proposal PDFs - 1.png": 53198,
	"./manual_action_planning/sv/Generating Action Proposal PDFs - 2.png": 80960,
	"./manual_action_planning/sv/Generating Action Proposal PDFs - 3.png": 19900,
	"./manual_action_planning/sv/Generating Action Proposal PDFs - 4.png": 50790,
	"./manual_action_planning/sv/Removing Actions from Action Plans - 1.png": 28474,
	"./manual_action_planning/sv/Removing Actions from Action Plans - 2.png": 79566,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 1.png": 39265,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 10.png": 57005,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 2.png": 58814,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 3.png": 13380,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 4.png": 6515,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 5.png": 57494,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 6.png": 93502,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 7.png": 92761,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 8.png": 97574,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 9.png": 60964,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 1.png": 91447,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 2.png": 73866,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 3.png": 57636,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 4.png": 75511,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 5.png": 45101,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 6.png": 52316,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 7.png": 75906,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 8.png": 95528,
	"./manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 9.png": 48348,
	"./manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 1.png": 19861,
	"./manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 2.png": 14284,
	"./manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 3.png": 57405,
	"./manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 4.png": 14106,
	"./manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 5.png": 21144,
	"./manual_advanced/en/Exporting Rapid Orthophotos - 1.png": 42293,
	"./manual_advanced/en/Exporting Rapid Orthophotos - 2.png": 18642,
	"./manual_advanced/en/Exporting Rapid Orthophotos - 3.png": 55631,
	"./manual_advanced/en/Importing Photos as Points - 1.png": 73054,
	"./manual_advanced/en/Importing Photos as Points - 2.png": 4338,
	"./manual_advanced/en/Importing Photos as Points - 3.png": 38679,
	"./manual_advanced/en/Language & Region.png": 83061,
	"./manual_advanced/en/Select Language.png": 44906,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 1.png": 23262,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 10.png": 6477,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 2.png": 72921,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 3.png": 43873,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 4.png": 24441,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 5.png": 68474,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 6.png": 24345,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 7.png": 58418,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 8.png": 14061,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 9.png": 99433,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 1.png": 76324,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 2.png": 46771,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 3.png": 63753,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 4.png": 34252,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 5.png": 43908,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 6.png": 1994,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 7.png": 15478,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 8.png": 15678,
	"./manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 9.png": 30839,
	"./manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 1.png": 29124,
	"./manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 2.png": 13009,
	"./manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 3.png": 37455,
	"./manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 4.png": 52438,
	"./manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 5.png": 54693,
	"./manual_advanced/sv/Exporting Rapid Orthophotos - 1.png": 17546,
	"./manual_advanced/sv/Exporting Rapid Orthophotos - 2.png": 82524,
	"./manual_advanced/sv/Exporting Rapid Orthophotos - 3.png": 38307,
	"./manual_advanced/sv/Importing Photos as Points - 1.png": 7420,
	"./manual_advanced/sv/Importing Photos as Points - 2.png": 36370,
	"./manual_advanced/sv/Importing Photos as Points - 3.png": 97200,
	"./manual_advanced/sv/Language & Region.png": 60985,
	"./manual_advanced/sv/Select Language.png": 61295,
	"./manual_basics/en/Active Tracklog - 1.png": 21909,
	"./manual_basics/en/Active Tracklog - 2.png": 50275,
	"./manual_basics/en/Active Tracklog - 3.png": 6966,
	"./manual_basics/en/AddNodeAtDronePositionTool.svg": 94193,
	"./manual_basics/en/AddNodeAtPositionTool.svg": 6105,
	"./manual_basics/en/Adding Photos from Camera - 1.png": 42251,
	"./manual_basics/en/Adding Photos from Camera - 2.png": 1562,
	"./manual_basics/en/Adding Photos from Camera - 3.png": 28269,
	"./manual_basics/en/Adding Photos from Camera - 4.png": 8921,
	"./manual_basics/en/Adding Photos from Camera - 5.png": 2969,
	"./manual_basics/en/Adding Photos from Library - 1.png": 48036,
	"./manual_basics/en/Adding Photos from Library - 2.png": 34755,
	"./manual_basics/en/Adding Photos from Library - 3.png": 1062,
	"./manual_basics/en/Adding Photos from Library - 4.png": 79091,
	"./manual_basics/en/Compact Example (iPhone) - Main Menu.png": 13716,
	"./manual_basics/en/Compact Example (iPhone) - Map.png": 42132,
	"./manual_basics/en/Copying Items in Teams - 1.png": 14994,
	"./manual_basics/en/Copying Items in Teams - 2.png": 86710,
	"./manual_basics/en/Copying Items in Teams - 3.png": 75514,
	"./manual_basics/en/Copying Items in Teams - 4.png": 39291,
	"./manual_basics/en/Copying Items in Teams - 5.png": 37025,
	"./manual_basics/en/Copying Items in Teams - 6.png": 41910,
	"./manual_basics/en/Creating Managed Areas - Draw & Import - 1.png": 40976,
	"./manual_basics/en/Creating Managed Areas - Draw & Import - 2.png": 13933,
	"./manual_basics/en/Creating Managed Areas - Draw - 3.png": 56919,
	"./manual_basics/en/Creating Managed Areas - Draw - 4.png": 58218,
	"./manual_basics/en/Creating Managed Areas - Draw - 5.png": 46624,
	"./manual_basics/en/Creating Managed Areas - Draw - 6.png": 44652,
	"./manual_basics/en/Creating Managed Areas - Estate - 1.png": 4713,
	"./manual_basics/en/Creating Managed Areas - Estate - 2.png": 34541,
	"./manual_basics/en/Creating Managed Areas - Estate - 3.png": 92093,
	"./manual_basics/en/Creating Managed Areas - Estate - 4.png": 87562,
	"./manual_basics/en/Creating Managed Areas - Import - 3.png": 36797,
	"./manual_basics/en/Creating Managed Areas - Import - 4.png": 26906,
	"./manual_basics/en/Creating Managed Areas - Import - 5.png": 97314,
	"./manual_basics/en/Creating Observations - Image Viewer - 1.png": 44830,
	"./manual_basics/en/Creating Observations - Image Viewer - 2.png": 25387,
	"./manual_basics/en/Creating Observations - Image Viewer - 3.png": 56192,
	"./manual_basics/en/Creating Observations - Map - 1.png": 15257,
	"./manual_basics/en/Creating Observations - Map - 2.png": 75369,
	"./manual_basics/en/Creating Observations - Map - 3.png": 35241,
	"./manual_basics/en/Creating Observations - Map - 4.png": 49431,
	"./manual_basics/en/Creating Observations - Map - 5.png": 73776,
	"./manual_basics/en/Creating Projects - 1.png": 40373,
	"./manual_basics/en/Creating Projects - 2.png": 65284,
	"./manual_basics/en/Creating Projects - 3.png": 16175,
	"./manual_basics/en/Creating Teams - 1.png": 87999,
	"./manual_basics/en/Creating Teams - 2.png": 30593,
	"./manual_basics/en/DeleteNodesTool.svg": 43194,
	"./manual_basics/en/DrawTool.svg": 36401,
	"./manual_basics/en/DroneTrackTool.svg": 19858,
	"./manual_basics/en/EditTool.svg": 12774,
	"./manual_basics/en/Filtering Compartments - 1.png": 88446,
	"./manual_basics/en/Filtering Compartments - 2.png": 98574,
	"./manual_basics/en/Filtering Compartments - 3.png": 94151,
	"./manual_basics/en/Filtering Compartments - 4.png": 20481,
	"./manual_basics/en/Geometry Editor.png": 68437,
	"./manual_basics/en/Managed Area - Available Offline.png": 81819,
	"./manual_basics/en/Managed Area.png": 6941,
	"./manual_basics/en/Map Layers.png": 48790,
	"./manual_basics/en/MergeTool.svg": 28843,
	"./manual_basics/en/Moving Items in Projects - 1.png": 59711,
	"./manual_basics/en/Moving Items in Projects - 2.png": 5933,
	"./manual_basics/en/Moving Items in Projects - 3.png": 27005,
	"./manual_basics/en/Moving Items in Projects - 4.png": 33240,
	"./manual_basics/en/Moving Items in Projects - 5.png": 70488,
	"./manual_basics/en/Moving Items in Projects - 6.png": 81335,
	"./manual_basics/en/Navigate to Teams from Managed Areas - 1.png": 53628,
	"./manual_basics/en/Navigate to Teams from Managed Areas - 2.png": 11044,
	"./manual_basics/en/Project - Restoring Deleted Item - 1.png": 64782,
	"./manual_basics/en/Project - Restoring Deleted Item - 2.png": 54746,
	"./manual_basics/en/Redo.svg": 62495,
	"./manual_basics/en/Report Error - 1.png": 31170,
	"./manual_basics/en/Report Error - 2.png": 10235,
	"./manual_basics/en/Report Error - 3.png": 83619,
	"./manual_basics/en/Select Map - 1.png": 96057,
	"./manual_basics/en/Select Map - 2.png": 67382,
	"./manual_basics/en/Select Map - 3.png": 50784,
	"./manual_basics/en/Select Map - 4.png": 81411,
	"./manual_basics/en/Signing In - 1.png": 52893,
	"./manual_basics/en/Signing In - 2.png": 52174,
	"./manual_basics/en/SplitTool.svg": 20614,
	"./manual_basics/en/SubtractTool.svg": 38653,
	"./manual_basics/en/Team - Restoring Deleted Item - 1.png": 25811,
	"./manual_basics/en/Team - Restoring Deleted Item - 2.png": 14873,
	"./manual_basics/en/The GUI - Overview.png": 5446,
	"./manual_basics/en/The GUI - Search.png": 28963,
	"./manual_basics/en/The GUI - The Detail Panel.png": 37415,
	"./manual_basics/en/The GUI - The Main Menu.png": 60563,
	"./manual_basics/en/The GUI - The Map.png": 5564,
	"./manual_basics/en/The GUI - The More-menu.png": 42562,
	"./manual_basics/en/TrackTool.svg": 65522,
	"./manual_basics/en/Undo.svg": 88895,
	"./manual_basics/sv/Active Tracklog - 1.png": 19586,
	"./manual_basics/sv/Active Tracklog - 2.png": 32380,
	"./manual_basics/sv/Active Tracklog - 3.png": 31404,
	"./manual_basics/sv/AddNodeAtDronePositionTool.svg": 6511,
	"./manual_basics/sv/AddNodeAtPositionTool.svg": 75592,
	"./manual_basics/sv/Adding Photos from Camera - 1.png": 99489,
	"./manual_basics/sv/Adding Photos from Camera - 2.png": 44507,
	"./manual_basics/sv/Adding Photos from Camera - 3.png": 77478,
	"./manual_basics/sv/Adding Photos from Camera - 4.png": 68122,
	"./manual_basics/sv/Adding Photos from Camera - 5.png": 23006,
	"./manual_basics/sv/Adding Photos from Library - 1.png": 47786,
	"./manual_basics/sv/Adding Photos from Library - 2.png": 86107,
	"./manual_basics/sv/Adding Photos from Library - 3.png": 21852,
	"./manual_basics/sv/Adding Photos from Library - 4.png": 25901,
	"./manual_basics/sv/Compact Example (iPhone) - Main Menu.png": 14645,
	"./manual_basics/sv/Compact Example (iPhone) - Map.png": 57502,
	"./manual_basics/sv/Copying Items in Teams - 1.png": 90512,
	"./manual_basics/sv/Copying Items in Teams - 2.png": 88727,
	"./manual_basics/sv/Copying Items in Teams - 3.png": 52991,
	"./manual_basics/sv/Copying Items in Teams - 4.png": 42513,
	"./manual_basics/sv/Copying Items in Teams - 5.png": 15836,
	"./manual_basics/sv/Copying Items in Teams - 6.png": 40822,
	"./manual_basics/sv/Creating Managed Areas - Draw & Import - 1.png": 29234,
	"./manual_basics/sv/Creating Managed Areas - Draw & Import - 2.png": 54515,
	"./manual_basics/sv/Creating Managed Areas - Draw - 3.png": 44715,
	"./manual_basics/sv/Creating Managed Areas - Draw - 4.png": 44497,
	"./manual_basics/sv/Creating Managed Areas - Draw - 5.png": 52669,
	"./manual_basics/sv/Creating Managed Areas - Draw - 6.png": 91885,
	"./manual_basics/sv/Creating Managed Areas - Estate - 1.png": 93906,
	"./manual_basics/sv/Creating Managed Areas - Estate - 2.png": 28402,
	"./manual_basics/sv/Creating Managed Areas - Estate - 3.png": 87661,
	"./manual_basics/sv/Creating Managed Areas - Estate - 4.png": 53449,
	"./manual_basics/sv/Creating Managed Areas - Import - 3.png": 58850,
	"./manual_basics/sv/Creating Managed Areas - Import - 4.png": 36989,
	"./manual_basics/sv/Creating Managed Areas - Import - 5.png": 486,
	"./manual_basics/sv/Creating Observations - Image Viewer - 1.png": 60621,
	"./manual_basics/sv/Creating Observations - Image Viewer - 2.png": 88944,
	"./manual_basics/sv/Creating Observations - Image Viewer - 3.png": 58164,
	"./manual_basics/sv/Creating Observations - Map - 1.png": 22963,
	"./manual_basics/sv/Creating Observations - Map - 2.png": 27894,
	"./manual_basics/sv/Creating Observations - Map - 3.png": 11258,
	"./manual_basics/sv/Creating Observations - Map - 4.png": 74725,
	"./manual_basics/sv/Creating Observations - Map - 5.png": 64229,
	"./manual_basics/sv/Creating Projects - 1.png": 15292,
	"./manual_basics/sv/Creating Projects - 2.png": 29017,
	"./manual_basics/sv/Creating Projects - 3.png": 3651,
	"./manual_basics/sv/Creating Teams - 1.png": 72593,
	"./manual_basics/sv/Creating Teams - 2.png": 27024,
	"./manual_basics/sv/DeleteNodesTool.svg": 34740,
	"./manual_basics/sv/DrawTool.svg": 96139,
	"./manual_basics/sv/DroneTrackTool.svg": 36318,
	"./manual_basics/sv/EditTool.svg": 65481,
	"./manual_basics/sv/Filtering Compartments - 1.png": 97941,
	"./manual_basics/sv/Filtering Compartments - 2.png": 42907,
	"./manual_basics/sv/Filtering Compartments - 3.png": 17102,
	"./manual_basics/sv/Filtering Compartments - 4.png": 59203,
	"./manual_basics/sv/Geometry Editor.png": 92032,
	"./manual_basics/sv/Managed Area - Available Offline.png": 99299,
	"./manual_basics/sv/Managed Area.png": 34281,
	"./manual_basics/sv/Map Layers.png": 15036,
	"./manual_basics/sv/MergeTool.svg": 66694,
	"./manual_basics/sv/Moving Items in Projects - 1.png": 75987,
	"./manual_basics/sv/Moving Items in Projects - 2.png": 50038,
	"./manual_basics/sv/Moving Items in Projects - 3.png": 29599,
	"./manual_basics/sv/Moving Items in Projects - 4.png": 5432,
	"./manual_basics/sv/Moving Items in Projects - 5.png": 96494,
	"./manual_basics/sv/Moving Items in Projects - 6.png": 41871,
	"./manual_basics/sv/Navigate to Teams from Managed Areas - 1.png": 34970,
	"./manual_basics/sv/Navigate to Teams from Managed Areas - 2.png": 41950,
	"./manual_basics/sv/Project - Restoring Deleted Item - 1.png": 8909,
	"./manual_basics/sv/Project - Restoring Deleted Item - 2.png": 51326,
	"./manual_basics/sv/Redo.svg": 46706,
	"./manual_basics/sv/Report Error - 1.png": 99960,
	"./manual_basics/sv/Report Error - 2.png": 91380,
	"./manual_basics/sv/Report Error - 3.png": 3909,
	"./manual_basics/sv/Select Map - 1.png": 54667,
	"./manual_basics/sv/Select Map - 2.png": 98286,
	"./manual_basics/sv/Select Map - 3.png": 44812,
	"./manual_basics/sv/Select Map - 4.png": 32791,
	"./manual_basics/sv/Signing In - 1.png": 36341,
	"./manual_basics/sv/Signing In - 2.png": 14001,
	"./manual_basics/sv/SplitTool.svg": 83946,
	"./manual_basics/sv/SubtractTool.svg": 78040,
	"./manual_basics/sv/Team - Restoring Deleted Item - 1.png": 43538,
	"./manual_basics/sv/Team - Restoring Deleted Item - 2.png": 47018,
	"./manual_basics/sv/The GUI - Overview.png": 58010,
	"./manual_basics/sv/The GUI - Search.png": 25757,
	"./manual_basics/sv/The GUI - The Detail Panel.png": 71321,
	"./manual_basics/sv/The GUI - The Main Menu.png": 11903,
	"./manual_basics/sv/The GUI - The Map.png": 74017,
	"./manual_basics/sv/The GUI - The More-menu.png": 72487,
	"./manual_basics/sv/TrackTool.svg": 90423,
	"./manual_basics/sv/Undo.svg": 47603,
	"./manual_drone_operations/en/Connecting to Enterprise Drone - 1.png": 12951,
	"./manual_drone_operations/en/Connecting to Enterprise Drone - 2.png": 20580,
	"./manual_drone_operations/en/Connecting to Enterprise Drone - 3.png": 29090,
	"./manual_drone_operations/en/Connecting to Enterprise Drone - 4.png": 75237,
	"./manual_drone_operations/en/Connecting to Enterprise Drone - 5.png": 10123,
	"./manual_drone_operations/en/Connecting to Enterprise Drone - 6.png": 78675,
	"./manual_drone_operations/en/Connecting to Enterprise Drone - 7.png": 85022,
	"./manual_drone_operations/en/Connecting to Other Drone - 1.png": 7631,
	"./manual_drone_operations/en/Connecting to Other Drone - 2.png": 2277,
	"./manual_drone_operations/en/Connecting to Other Drone - 3.png": 80581,
	"./manual_drone_operations/en/Connecting to Other Drone - 4.png": 22470,
	"./manual_drone_operations/en/Creating Drone Missions - 1.png": 14301,
	"./manual_drone_operations/en/Creating Drone Missions - 2.png": 76775,
	"./manual_drone_operations/en/Creating Drone Missions - 3.png": 57728,
	"./manual_drone_operations/en/Creating Drone Missions - 4.png": 11380,
	"./manual_drone_operations/en/Creating Drone Missions - 5.png": 1656,
	"./manual_drone_operations/en/Creating Drone Missions - 6.png": 87467,
	"./manual_drone_operations/en/Displaying Rapid Orthophotos - 1.png": 20859,
	"./manual_drone_operations/en/Displaying Rapid Orthophotos - 2.png": 22504,
	"./manual_drone_operations/en/Downloading Rapid Orthophotos - 1.png": 22544,
	"./manual_drone_operations/en/Downloading Rapid Orthophotos - 2.png": 39081,
	"./manual_drone_operations/en/Downloading Rapid Orthophotos - 3.png": 96365,
	"./manual_drone_operations/en/Hide or Clear Flight Path.png": 71999,
	"./manual_drone_operations/en/Importing Flight Images - 1.png": 63666,
	"./manual_drone_operations/en/Importing Flight Images - 2.png": 67275,
	"./manual_drone_operations/en/Importing Flight Images - 3.png": 15486,
	"./manual_drone_operations/en/Merging Rapid Orthophotos - 1.png": 70815,
	"./manual_drone_operations/en/Merging Rapid Orthophotos - 2.png": 54325,
	"./manual_drone_operations/en/Merging Rapid Orthophotos - 3.png": 5474,
	"./manual_drone_operations/en/Merging Rapid Orthophotos - 4.png": 49112,
	"./manual_drone_operations/en/Merging Rapid Orthophotos - 5.png": 63498,
	"./manual_drone_operations/en/Merging Rapid Orthophotos - 6.png": 43162,
	"./manual_drone_operations/en/Merging Rapid Orthophotos - 7.png": 17042,
	"./manual_drone_operations/en/RNG Switch.png": 91882,
	"./manual_drone_operations/en/Show Temp Switch.png": 67484,
	"./manual_drone_operations/en/Starting Drone Missions.png": 77872,
	"./manual_drone_operations/en/The Drone GUI - GF - Drone.png": 21046,
	"./manual_drone_operations/en/The Drone GUI - GF - Map.png": 75764,
	"./manual_drone_operations/en/The Drone GUI - GF Pilot.png": 80135,
	"./manual_drone_operations/sv/Connecting to Enterprise Drone - 1.png": 47122,
	"./manual_drone_operations/sv/Connecting to Enterprise Drone - 2.png": 96169,
	"./manual_drone_operations/sv/Connecting to Enterprise Drone - 3.png": 79685,
	"./manual_drone_operations/sv/Connecting to Enterprise Drone - 4.png": 92500,
	"./manual_drone_operations/sv/Connecting to Enterprise Drone - 5.png": 95955,
	"./manual_drone_operations/sv/Connecting to Enterprise Drone - 6.png": 58730,
	"./manual_drone_operations/sv/Connecting to Enterprise Drone - 7.png": 40663,
	"./manual_drone_operations/sv/Connecting to Other Drone - 1.png": 71938,
	"./manual_drone_operations/sv/Connecting to Other Drone - 2.png": 48223,
	"./manual_drone_operations/sv/Connecting to Other Drone - 3.png": 80333,
	"./manual_drone_operations/sv/Connecting to Other Drone - 4.png": 48081,
	"./manual_drone_operations/sv/Creating Drone Missions - 1.png": 35412,
	"./manual_drone_operations/sv/Creating Drone Missions - 2.png": 25297,
	"./manual_drone_operations/sv/Creating Drone Missions - 3.png": 62586,
	"./manual_drone_operations/sv/Creating Drone Missions - 4.png": 46552,
	"./manual_drone_operations/sv/Creating Drone Missions - 5.png": 35441,
	"./manual_drone_operations/sv/Creating Drone Missions - 6.png": 68082,
	"./manual_drone_operations/sv/Displaying Rapid Orthophotos - 1.png": 97157,
	"./manual_drone_operations/sv/Displaying Rapid Orthophotos - 2.png": 56272,
	"./manual_drone_operations/sv/Downloading Rapid Orthophotos - 1.png": 26045,
	"./manual_drone_operations/sv/Downloading Rapid Orthophotos - 2.png": 18876,
	"./manual_drone_operations/sv/Downloading Rapid Orthophotos - 3.png": 82020,
	"./manual_drone_operations/sv/Hide or Clear Flight Path.png": 31817,
	"./manual_drone_operations/sv/Importing Flight Images - 1.png": 50601,
	"./manual_drone_operations/sv/Importing Flight Images - 2.png": 67687,
	"./manual_drone_operations/sv/Importing Flight Images - 3.png": 95747,
	"./manual_drone_operations/sv/Merging Rapid Orthophotos - 1.png": 44051,
	"./manual_drone_operations/sv/Merging Rapid Orthophotos - 2.png": 98274,
	"./manual_drone_operations/sv/Merging Rapid Orthophotos - 3.png": 59624,
	"./manual_drone_operations/sv/Merging Rapid Orthophotos - 4.png": 70786,
	"./manual_drone_operations/sv/Merging Rapid Orthophotos - 5.png": 72119,
	"./manual_drone_operations/sv/Merging Rapid Orthophotos - 6.png": 89903,
	"./manual_drone_operations/sv/Merging Rapid Orthophotos - 7.png": 21257,
	"./manual_drone_operations/sv/RNG Switch.png": 35503,
	"./manual_drone_operations/sv/Show Temp Switch.png": 91647,
	"./manual_drone_operations/sv/Starting Drone Missions.png": 30255,
	"./manual_drone_operations/sv/The Drone GUI - GF - Drone.png": 17615,
	"./manual_drone_operations/sv/The Drone GUI - GF - Map.png": 36862,
	"./manual_drone_operations/sv/The Drone GUI - GF Pilot.png": 65650,
	"./manual_forest_management_planning/en/Creating Forest Management Planning Projects - 1.png": 29122,
	"./manual_forest_management_planning/en/Creating Forest Management Planning Projects - 2.png": 11023,
	"./manual_forest_management_planning/en/Extending Compartments - 1.png": 68459,
	"./manual_forest_management_planning/en/Extending Compartments - 2.png": 37609,
	"./manual_forest_management_planning/en/Extending Compartments - 3.png": 60685,
	"./manual_forest_management_planning/en/Merging Compartments - 1.png": 2976,
	"./manual_forest_management_planning/en/Merging Compartments - 2.png": 77037,
	"./manual_forest_management_planning/en/Merging Compartments - 3.png": 27502,
	"./manual_forest_management_planning/en/Splitting Compartments - 1.png": 20714,
	"./manual_forest_management_planning/en/Splitting Compartments - 2.png": 86386,
	"./manual_forest_management_planning/en/Splitting Compartments - 3.png": 12860,
	"./manual_forest_management_planning/en/Splitting Compartments - 4.png": 45335,
	"./manual_forest_management_planning/sv/Creating Forest Management Planning Projects - 1.png": 27737,
	"./manual_forest_management_planning/sv/Creating Forest Management Planning Projects - 2.png": 87784,
	"./manual_forest_management_planning/sv/Extending Compartments - 1.png": 77538,
	"./manual_forest_management_planning/sv/Extending Compartments - 2.png": 77052,
	"./manual_forest_management_planning/sv/Extending Compartments - 3.png": 16536,
	"./manual_forest_management_planning/sv/Merging Compartments - 1.png": 25377,
	"./manual_forest_management_planning/sv/Merging Compartments - 2.png": 59846,
	"./manual_forest_management_planning/sv/Merging Compartments - 3.png": 18126,
	"./manual_forest_management_planning/sv/Splitting Compartments - 1.png": 74500,
	"./manual_forest_management_planning/sv/Splitting Compartments - 2.png": 7775,
	"./manual_forest_management_planning/sv/Splitting Compartments - 3.png": 19966,
	"./manual_forest_management_planning/sv/Splitting Compartments - 4.png": 34984,
	"./planning_drone_praxis/en/planning-drone-praxis-1-cropped.png": 12538,
	"./planning_drone_praxis/en/planning-drone-praxis-2-cropped.png": 63265,
	"./planning_drone_praxis/sv/planning-drone-praxis-1-cropped.png": 82541,
	"./planning_drone_praxis/sv/planning-drone-praxis-2-cropped.png": 35209,
	"./sfab_forest_management_planning/en/sfab-forest-management-planning-1-cropped.png": 49099,
	"./sfab_forest_management_planning/en/sfab-forest-management-planning-2-cropped.png": 91694,
	"./sfab_forest_management_planning/sv/sfab-forest-management-planning-1-cropped.png": 21421,
	"./sfab_forest_management_planning/sv/sfab-forest-management-planning-2-cropped.png": 13039,
	"./stora_enso_bark_beetle/en/stora-enso-bark-beetle-1-cropped.png": 2053,
	"./stora_enso_bark_beetle/en/stora-enso-bark-beetle-2-cropped.png": 95037,
	"./stora_enso_bark_beetle/sv/stora-enso-bark-beetle-1-cropped.png": 27387,
	"./stora_enso_bark_beetle/sv/stora-enso-bark-beetle-2-cropped.png": 4016,
	"./wildfires_and_prescribed_fire/en/DJI_20250520210131_0006_V.jpg": 37951,
	"./wildfires_and_prescribed_fire/en/DJI_20250520215418_0015_T.jpg": 10733,
	"./wildfires_and_prescribed_fire/en/DJI_20250520215442_0016_V.jpg": 48988,
	"./wildfires_and_prescribed_fire/en/IMG_1684.png": 80599,
	"./wildfires_and_prescribed_fire/en/IMG_1686.png": 73030,
	"./wildfires_and_prescribed_fire/sv/DJI_20250520210131_0006_V.jpg": 17074,
	"./wildfires_and_prescribed_fire/sv/DJI_20250520215418_0015_T.jpg": 8684,
	"./wildfires_and_prescribed_fire/sv/DJI_20250520215442_0016_V.jpg": 27654,
	"./wildfires_and_prescribed_fire/sv/IMG_1684.png": 56581,
	"./wildfires_and_prescribed_fire/sv/IMG_1686.png": 588,
	"./wildlife/en/wildlife-boars-cropped.png": 54936,
	"./wildlife/en/wildlife-ir-zoomed-out-cropped.png": 57473,
	"./wildlife/en/wildlife-moose-cropped.png": 82245,
	"./wildlife/en/wildlife-rgb-zoomed-in-cropped.png": 93614,
	"./wildlife/sv/wildlife-boars-cropped.png": 28421,
	"./wildlife/sv/wildlife-ir-zoomed-out-cropped.png": 29556,
	"./wildlife/sv/wildlife-moose-cropped.png": 52449,
	"./wildlife/sv/wildlife-rgb-zoomed-in-cropped.png": 25624,
	"./windthrow/en/IMG_1673.png": 28533,
	"./windthrow/en/IMG_1674.png": 49449,
	"./windthrow/en/norra-observations-cropped.png": 55854,
	"./windthrow/en/norra-pre-observations-cropped.png": 40612,
	"./windthrow/en/windthrow-area.png": 80048,
	"./windthrow/en/windthrow-details-cropped.png": 85269,
	"./windthrow/en/windthrow-timber.png": 99725,
	"./windthrow/sv/IMG_1673.png": 57113,
	"./windthrow/sv/IMG_1674.png": 59680,
	"./windthrow/sv/norra-observations-cropped.png": 66526,
	"./windthrow/sv/norra-pre-observations-cropped.png": 56917,
	"./windthrow/sv/windthrow-area.png": 22015,
	"./windthrow/sv/windthrow-details-cropped.png": 28627,
	"./windthrow/sv/windthrow-timber.png": 88410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44433;